module.exports = __webpack_public_path__ + "static/img/8.cc813e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/eng/8.png
// module id = DEF2
// module chunks = 0